var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "{styles.squircle} ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8496C0 2.44445 2.44445 0 13.8496 0H18.1504C29.5555 0 32 2.44445 32 13.8496V18.1504C32 29.5555 29.5555 32 18.1504 32H13.8496C2.44445 32 0 29.5555 0 18.1504V13.8496Z",
    fill: "#459BC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquircle);
export default __webpack_public_path__ + "static/media/squircle.7d4e7835438232187d77e30c65c4f5ca.svg";
export { ForwardRef as ReactComponent };